import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getCatalogsCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/catalog/count', options);
  }

  public getCatalogsList(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/catalog/all', options);
  }

  public getCatalogInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { internalId };
    return this.http.get(this.BASE_URL + 'private/v2.0/catalog', options);
  }

  public addNewCatalog(context, lang, udid, image, active, description, ordering, backgroundColor, textColor, printInmediately) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { image, active, description, ordering, backgroundColor, textColor, printInmediately };
    return this.http.post(this.BASE_URL + 'private/v2.0/catalog', item, options);
  }

  public getCatalogDevicesMCatalog(context, lang, udid, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { centerInternalIds };
    return this.http.get(this.BASE_URL + 'private/v2.0/catalog/devices/mcatalog', options);
  }

  public getCatalogDevicesStaff(context, lang, udid, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { centerInternalIds };
    return this.http.get(this.BASE_URL + 'private/v2.0/catalog/devices/staff', options);
  }

  public getCatalogDesks(context, lang, udid, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { centerInternalIds };
    return this.http.get(this.BASE_URL + 'private/v2.0/catalog/desks', options);
  }

  public updateCatalogStatus(context, lang, udid, internalId, active) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog', item, options);
  }

  public updateCatalogImage(context, lang, udid, internalId, image) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, image };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog', item, options);
  }

  public updateCatalogInfo(context, lang, udid, internalId, active, description, ordering, backgroundColor, textColor) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, description, ordering, backgroundColor, textColor };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog', item, options);
  }

  public updateCatalogCenters(context, lang, udid, catalog, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { catalog, internalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog/center', item, options);
  }
  public updateCatalogDesks(context, lang, udid, catalog, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { catalog, internalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog/desk', item, options);
  }
  public updateCatalogDevicesMCatalog(context, lang, udid, catalog, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { catalog, internalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog/device/mcatalog', item, options);
  }
  public updateCatalogDevicesStaff(context, lang, udid, catalog, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { catalog, internalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog/device/staff', item, options);
  }
  public updateCatalogPrintInmediately(context, lang, udid, internalId, printInmediately) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, printInmediately };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog', item, options);
  }
  public updateCatalogProducts(context, lang, udid, catalog, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { catalog, internalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/catalog/product', item, options);
  }

  public deleteCatalog(context, lang, udid, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['body'] = { internalIds };
    return this.http.request('delete', this.BASE_URL + 'private/v2.0/catalog', options);
  }
}
